import { render, staticRenderFns } from "./SelectProject.vue?vue&type=template&id=dfd8f40c&scoped=true&"
import script from "./SelectProject.vue?vue&type=script&lang=js&"
export * from "./SelectProject.vue?vue&type=script&lang=js&"
import style0 from "./SelectProject.vue?vue&type=style&index=0&id=dfd8f40c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd8f40c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
